/** Personal preference across both ledgers; stale ids never hide new categories. */
export function mergeGrid<T extends { id: string }>(personal: readonly T[], family: readonly T[], order?: readonly string[] | null): T[] {
  const rows = [...personal, ...family];
  const byId = new Map(rows.map(row => [row.id, row]));
  const result: T[] = [];
  for (const id of [...(order ?? []), ...rows.map(row => row.id)]) {
    const row = byId.get(id);
    if (row) { result.push(row); byId.delete(id); }
  }
  return result;
}
